import { OrigemProcesso, Processo } from ".";
import { Relator } from "./dominio/Relator";
import { ClasseJudicialDto } from "./dto/ClasseJudicialDto";
import { OrgaoJulgadorDto } from "./dto/OrgaoJulgadorDto";
import { DadosProcessoDto } from "./dto/DadosProcessoDto";

export class ProcessoExterno extends Processo {


    public static novoProcessoExterno(processoExtDto: Partial<ProcessoExternoDto>): ProcessoExterno {
        if (!processoExtDto) {
            processoExtDto = {};
        }

        const procGab = Processo.novo({}) as ProcessoExterno;
        procGab.identificadorProcesso = processoExtDto.identificadorProcesso
        procGab.relator = processoExtDto.relator;
        procGab.classeJudicial = processoExtDto.classes[0];
        procGab.classes = processoExtDto.classes.map(classe => classe.sigla).join('-');

        // const mobxInicial = ProcessoExterno.mobxInicial();
        // extendObservable(procGab, mobxInicial);
        procGab.numeroProcesso = processoExtDto.numeroProcesso?.length > 25 ? processoExtDto.numeroProcesso : procGab.classes + ' - ' + processoExtDto.numeroProcesso;
        procGab.classe = processoExtDto.classe;
        procGab.dataAutuacaoTst = processoExtDto.dataAutuacao as unknown as string;
        // procGab.prioridades = processoExtDto.prioridades;
        procGab.origemProcesso = { id: processoExtDto.origem as OrigemProcesso, descricao: '' };
        procGab.orgaoJulgador = processoExtDto.orgaoJulgador;
        procGab.orgaoJulgadorColegiado = processoExtDto.orgaoJulgadorColegiado;
        procGab.classesDTO = processoExtDto.classes;

        return procGab;
    }

    public static novoProcessoExternoParaImportar(processoDto: Partial<DadosProcessoDto>): ProcessoExterno {
        if (!processoDto) {
            processoDto = {};
            return Processo.novo({}) as ProcessoExterno
        }

        const procGab = Processo.novo({}) as ProcessoExterno;
        procGab.identificadorProcesso = processoDto.identificadorProcesso
        procGab.relator = processoDto.relator;
        procGab.classeJudicial = processoDto.classesJudicial[0];
        procGab.classes = processoDto.classesJudicial.map(classe => classe.sigla).join('-');

        // const mobxInicial = ProcessoExterno.mobxInicial();
        // extendObservable(procGab, mobxInicial);
        procGab.numeroProcesso = processoDto.numero?.length > 25 ? processoDto.numero : procGab.classes + ' - ' + processoDto.numero;
        procGab.classe = procGab.classeJudicial.sigla;
        procGab.dataAutuacaoTst = new Date(processoDto.dataAutuacaoTst) as unknown as string;
        // procGab.prioridades = processoExtDto.prioridades;
        procGab.origemProcesso = { id: processoDto.origem as OrigemProcesso, descricao:''};
        procGab.orgaoJulgador = processoDto.orgaoJulgador;
        procGab.orgaoJulgadorColegiado = processoDto.orgaoJulgadorColegiado;
        procGab.classesDTO = processoDto.classesJudicial;

        return procGab;
    }

    classesDTO: ClasseJudicialDto[];
    ehAgravo: boolean;
    ehRecursoInterno: boolean;
    ehEmbargo: boolean;
}


export class ProcessoExternoDto {
    identificadorProcesso: number;
    numeroProcesso: string;
    classe: string;
    dataAutuacao: Date;
    prioridades: any[]
    origem: string;
    orgaoJulgador: OrgaoJulgadorDto;
    orgaoJulgadorColegiado: OrgaoJulgadorDto;
    classes: ClasseJudicialDto[];
    relator: Relator
}
